import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface Notification {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  AllNotifications?: any;
}
let initialState: Notification = {
  isLoading: false,
  error: false,
  message: null,
  AllNotifications: [],
};
const NotificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    loadingNotifications: (state: Notification, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setNotifications: (state: any, action: PayloadAction<Notification>) => {
      return action.payload;
    },
    clearData: (state: Notification, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingNotifications, setNotifications, clearData } =
  NotificationSlice.actions;

export default NotificationSlice.reducer;
